import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import InputSearch from "../components/InputSearch";
import Table from "../ui/tables/Table";
import {findQueryText, sorter} from "../utils/Utils";
import {RowItemAvatarName, RowItemChip, RowPricePromo} from "./TableAtoms";
import {useAppSelector} from "../redux/store";

export default function IngredientTable() {
  const ingredients = useAppSelector((state) => state.database.ingredients);
  const navigate = useNavigate();
  const [query, setQuery] = useState("");

  const data = sorter(
    ingredients.filter((a) => findQueryText(a.name, query)),
    "name"
  );

  return (
    <>
      <div className="mb-2 grid grid-cols-1 md:grid-cols-2 gap-4">
        <InputSearch
          value={query}
          onChange={setQuery}
          onClear={() => setQuery("")}
        />
      </div>
      <Table
        columns={["Nombre", "Promo", "Precio", "Disponible", "Publicado"]}
        data={data.map((item) => [
          <RowItemAvatarName
            name={item.name}
            description={item.internal}
            hideMedia
          />,
          <RowItemChip value={item.showSalePrice} />,
          <RowPricePromo
            price={item.price}
            salePrice={item.salePrice}
            showSalePrice={item.showSalePrice}
          />,
          <RowItemChip value={item.available} />,
          <RowItemChip value={item.published} />,
          item,
        ])}
        onClick={(index) => {
          navigate(`/menu/ingredients/${data[index].id}`);
        }}
      />
    </>
  );
}
